import { JSX, ReactNode, useState, useEffect } from 'react'

import { Center, VStack, Text, Spinner, Image } from '@chakra-ui/react'

import { Http } from '@/lib/request.js'
import { Throttle } from '@/lib/alchemy.js'

import * as detective from '@/lib/detective.js'

import * as stamp_storage from '@/storage/stamp.js'
import * as authorize_storage from '@/storage/authorize.js'




export async function create
(): Promise<{ src: string, expire: Date }>
{
	let cypher = await authorize_storage.query()

	let res = stamp_storage.create(cypher, '/pages/authorize')

	let src = await res.get('x-access-uri', '')
	let access_control_max_age = await res.get('access-control-max-age', '0')

	let expire = Http.now

	expire.setSeconds(
		expire.getSeconds() + Number(access_control_max_age),

	)

	return { src, expire }


}


export default function
(
	props: {
		dispatch(expire: Date): void

	},

)
:	JSX.Element
{
	let [value, dispatch] = useState<ReactNode>(<Spinner size="xl" color="blue.500" />)

	useEffect(
		Throttle.once(
			async (): Promise<void> =>
			{
				let { src, expire } = await create()

				if (detective.is_required_string(src) && expire > Http.now)
				{
					props.dispatch(expire)

					dispatch(<Image boxSize="full" src={src} />)

				}


			},

			{ void: true },

		),

		[],


	)

	return (
		<Center h="full">
			<VStack gap="8">
				<Text fontSize="2xl" fontWeight="bold">扫码登录</Text>

				<Center w="sm" h="sm" bg="bg.subtle" rounded="2xl">{value}</Center>
			</VStack>

		</Center>

	)

}
